import get from 'lodash/get';
import queryString from 'query-string';
import * as constants from 'Constants';

export function isProduction() {
  if (process.env.NODE_ENV === 'production') {
    return true;
  } else {
    return false;
  }
}

export function stringContains(string, subString) {
  return string.indexOf(subString) !== -1;
}

export function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export function isMobileScreen() {
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  return screenWidth >= 768 ? false : true;
}

export function currentURL() {
  return window.location.href;
}

export function currentURLWithoutParams() {
  return window.location.protocol + '//' + window.location.host + window.location.pathname;
}

export function currentDomain() {
  return window.location.hostname;
}

export function appendQueryString(url, qs) {
  const parsed = queryString.parseUrl(url);
  qs = {...parsed.query, ...qs};

  Object.keys(qs).forEach((key) => (qs[key] === null || qs[key] === "") && delete qs[key]);
  let stringified = queryString.stringify(qs);
  if (!stringified) {
    return url;
  } else {
    return url + "?" + stringified;
  }
}

export function parseQueryString(val) {
  return queryString.parse(val);
}

export function removeQueryString(url) {
  return url.split("?")[0];
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
